<template>
  <v-layout class="patient-page" column>
 
      <v-card flat class="ma-2 mt-4">
        <v-layout align-center row>
        <v-text-field
          ref="input" 
          hide-details 
          solo 
          flat 
          background-color="transparent" 
          class="search-field mt-2"
          :placeholder="'Document ID'" 
          v-model="search" 
          prepend-icon="search"/>
          <v-btn @click="setFileInfo(search)">Go</v-btn>
        </v-layout>


        <v-data-table v-if="filesToDisplay" v-show="showTable" :headers="headers" :items="filesToDisplay" sort-icon="" class="flat mb-2 table-border" :rows-per-page-items="[10,25,{text: 'All', value:-1}]" :search="search">
          <template slot="items" slot-scope="props">
            <tr style="cursor:pointer" @click="setFileInfo(props.item.id)">
              <td> {{ props.item.id }}</td>
              <td> {{ displayPatientName(props.item) }}</td>
              <td class="text-xs-left">{{ formatDate(props.item.encounterDate) }}</td>
              <td class="text-xs-left">{{ displayProvider(props.item) }}</td>
              <td class="text-xs-left">{{ props.item.recordType }}</td>
              <td class="text-xs-left">{{ formatDate(props.item.created) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>


    <!-- <upload-dialog ref="uploadDialog" /> -->

  </v-layout>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';

.table-border {
  border: 1px solid #f5f5f5;
}

.search-field {
  background: #f5f5f5;
  border-radius: 4px;
  padding-left: 18px;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.headerTabUnselected:hover {
  opacity: 1;
}

.account-title {
  font-size: 24px;
  line-height: 30px;
  color: white;
}
</style>

<script>
import { mapActions, mapState } from 'vuex'
import Titlebar from '@/components/Titlebar'
import UploadDialog from '@/components/dialogs/UploadDialog'
import bus from '@/core/helpers/bus'

export default {
  components: {
    Titlebar,
    UploadDialog
  },
  data() {
    return {
      search: '',
      showTable: false,
      filesToDisplay: [],
      headers: [
        {
          text: 'File ID',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Patient',
          align: 'left',
          sortable: false,
          value: 'patient.lastName'
        },
        {
          text: 'Encounter Date',
          sortable: false,
          value: 'encounterDate',
          align: 'left'
        },
        {
          text: 'Provider',
          sortable: false,
          value: 'provider.id',
          align: 'left'
        },
        {
          text: 'Record Type',
          sortable: false,
          value: 'recordType',
          align: 'left'
        },
        {
          text: 'Created Date',
          sortable: true,
          value: 'created',
          align: 'left'
        }
      ]
    }
  },
  methods: {
    ...mapActions('admin', ['getUploads', 'getPatient', 'getFiles']),
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    displayPatientName(item) {
      if (item.patient) {
        if (item.patient.lastName) {
          if (item.patient.firstName) {
            return item.patient.lastName + ', ' + item.patient.firstName
          }
          return item.patient.lastName
        }
      }
      return ''
    },
    displayProvider(item) {
      console.log(item)
      if (item.renderingProvider) {
        return item.renderingProvider.id
      }
      return ''
    },
    formatDate(timestamp) {
      if (timestamp != null) {
        let d = new Date(timestamp * 1000)
        let MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
        return MyDateString
      }
      return ''
    },
    adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      })
    },
    setFileInfo(fileId) {
      this.$router.push({
        name: 'AdminFileUploadPage',
        query: { file: fileId }
      })
    },
    reduceFileCount() {
      let newFiles = []

      this.files.forEach(file => {
        // check to see if it has a patient. if it does, check for last name. if it is null, throw it out
        // check to see if if has an encounter date, provider, type and patient. if it does, throw it out.
        let include = false

        if (file.encounterDate) {
          // do nothing
        } else {
          include = true
        }

        if (file.renderingProvider) {
          // do nothing
        } else {
          include = true
        }

        if (file.recordType) {
          // do nothing
        } else {
          include = true
        }

        if (file.patient) {
          if (!file.patient.lastName) {
            include = false
          }
        } else {
          include = true
        }

        if (include) {
          newFiles.push(file)
        }
      })
      this.showTable = true
      this.filesToDisplay = newFiles
    }
  },
  computed: {
    ...mapState('admin', ['uploads', 'patient', 'upload', 'files']),
    // TODO: Provider auth info?
    ...mapState('patient', ['providerAuthInfo'])
  },
  created() {
    // this.getRequests()
    // this.getUploads()
    // this.getFiles()
    // bus.$emit('startPageLoading')
  },
  // TODO:
  watch: {
    files() {
      bus.$emit('stopPageLoading')
      this.reduceFileCount()
    },
    request() {
      this.requests.find((r, i) => {
        if (r._id === this.request.id) {
          this.requests[i].status = this.request.status.status
          return true
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/admin/AdminUploadsPage.vue